import grafic from "../../Assets/Images/Ökobilanz_Ecodesign.png";
import "./EcoDesignPage.style.css";

import EcoDesignMap from "../../Components/EcoDesignMap/EcoDesignMap";
import Data from "../../Assets/Content/EcoDesignData";
import ContentData from "../../Assets/Content/ContentData";
import { useEffect } from "react";
import ExpandableCard from "../../Components/ExpandableCard/ExpandableCard";
import EconomySwitch from "../../Components/EconomySwitch/EconomySwitch";

const EcoDesignPage = (props) => {
  const { content, setContent, economyType } = props.AppStateService;
  const { circularEconomyState, onChangeEconomySwitch } = props;

  useEffect(() => {
    document.title = "Kreislaufwirtschaftsguide | EcoDesign";
    setFixText();
  }, [economyType]);

  let setFixText = () => {
    if (economyType === "linear") {
      setContent(ContentData.LinearMain);
    } else {
      setContent(Data.Main);
    }
  };

  const isLinear = economyType === "linear";

  return (
    <div className="container-fluid mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <ExpandableCard title="Eco-Design" initiallyOpen={true}>
            <div className="sticky-switch-container">
              <EconomySwitch
                onChangeEconomySwitch={onChangeEconomySwitch}
                circularEconomyState={circularEconomyState}
              />
            </div>
            <div className="hover-text mb-3">
              Fahren sie mit der Maus über die Elemente der Grafik, um mehr zu
              erfahren.
            </div>
            <div className="row align-items-start">
              <div className="col-lg-8" id="eco-map-container">
                <img
                  src={grafic}
                  alt=""
                  // Disable map if linear
                  useMap={isLinear ? undefined : "#image-map-full"}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                  }}
                  onClick={() => {
                    setFixText();
                  }}
                />
                {!isLinear && (
                  <EcoDesignMap
                    AppStateService={{
                      setContent,
                      setFixText,
                    }}
                  />
                )}
              </div>
              <div className="col-lg-4 eco-text-container mt-3 mt-lg-0">
                <div className="heading">
                  {isLinear
                    ? ContentData.LinearMain.heading
                    : content?.heading || Data.Main.heading}
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: (isLinear
                      ? ContentData.LinearMain.text
                      : content?.text || Data.Main.text
                    )?.replace(/\n/g, "<br />"),
                  }}
                />
              </div>
            </div>
          </ExpandableCard>
        </div>
      </div>
    </div>
  );
};

export default EcoDesignPage;
